import { ArrowUpRight } from "@phosphor-icons/react";
import { Reveal } from "../lib/motion";
import { Btn } from "./Btn";

export default function ContactCTA() {
  return (
    <section data-testid="contact-cta" className="relative py-24 md:py-32 bg-white overflow-hidden">
      <div className="container-ballk">
        <Reveal>
          <div className="relative bg-ballk-purple rounded-[28px] overflow-hidden px-8 py-16 md:px-20 md:py-24 diag-both">
            {/* geometric lines */}
            <div className="absolute inset-0 opacity-[0.12] pointer-events-none">
              <div className="absolute -right-10 -top-10 h-64 w-64 border border-white rounded-full" />
              <div className="absolute right-24 top-24 h-40 w-40 border border-white"
                style={{ clipPath: "polygon(0 0, 100% 0, 70% 100%, 0 100%)" }} />
            </div>
            <div className="relative max-w-3xl">
              <p className="eyebrow text-white/70 mb-5">Samenwerken</p>
              <h2 className="font-heading font-bold text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                Samen bouwen aan wat belangrijk is.
              </h2>
              <p className="mt-6 text-white/80 text-base md:text-lg max-w-xl leading-relaxed">
                Van eerste idee tot oplevering — met één vast aanspreekpunt, heldere communicatie en grip op planning en budget.
              </p>
              <div className="mt-10">
                <Btn to="/contact" variant="secondary" data-testid="cta-contact-btn"
                  className="bg-white border-white text-ballk-purple hover:bg-ballk-light">
                  Neem contact op <ArrowUpRight size={18} weight="bold" />
                </Btn>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
